import { render, staticRenderFns } from "./animated_number.vue?vue&type=template&id=3c0e222f&"
import script from "./animated_number.vue?vue&type=script&lang=coffee&"
export * from "./animated_number.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports